import { enumValues } from "@adora/shared/utils/enum";

export type Platform = "meta" | "google" | "msan" | "pinterest";
export type UIPlatformName = "GDN" | "Meta" | "MSAN" | "Pinterest";
export const PLATFORMS: Record<string, Platform> = {
  GDN: "google",
  META: "meta",
  MSAN: "msan",
  PINTEREST: "pinterest"
} as const;

export const URL_PARAM_PLATFORMS: Record<string, UIPlatformName> = {
  google: "GDN",
  meta: "Meta",
  msan: "MSAN",
  pinterest: "Pinterest"
} as const;

export type COMMON_PLATFORMS_CAPITALIZED = "GDN" | "META" | "MSAN";
export const PLATFORM_SELECTOR_DISPLAY_NAMES: Record<COMMON_PLATFORMS_CAPITALIZED, string> = {
  GDN: "Google Display Network",
  META: "Meta",
  MSAN: "Microsoft Audience Network"
} as const;

export function isPlatform(str: string): str is Platform {
  return enumValues(PLATFORMS).includes(str as Platform);
}

export type PlatformKey = keyof typeof PLATFORMS;

export enum PlatformEnum {
  GDN = "google",
  META = "meta",
  MSAN = "msan",
  PINTEREST = "pinterest"
}
